import { Configuration, LogLevel } from '@azure/msal-browser';
import { AppConfig } from '../config/AppConfig';

export const msalConfig: Configuration = {
    auth: {
        clientId: AppConfig.microsoftAuthClientId,
        authority: AppConfig.microsoftAuthAuthority,
        redirectUri: AppConfig.microsoftRedirectUri,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Warning,
            piiLoggingEnabled: false,
        },
    },
};

export const loginRequest = {
    scopes: ['openid', 'profile', 'email', 'offline_access'],
};
